<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{ data.editing ? data.sysText.editNonWorkday_header : data.sysText.addNonWorkday_header }}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="cancel()" [attr.aria-label]="data.sysText.cancel" [disabled]="editingRow || (isSubmitting$ | async)">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <form [formGroup]="form">
    <app-input-field
      [control]="form.controls.name"
      [icon]="'subject'"
      [hideIconSpace]="isHandheld$ | async"
      [label]="data.sysText.name"
      [inputType]="'string'">
    </app-input-field>
    @if (data.dialogData.showOwner) {
      <div>
        <app-select-field
          [control]="form.controls.ownerEmployerId"
          [label]="data.sysText.owner"
          [options]="data.dialogData.employerOptions"
          [icon]="'business'"
          [hideIconSpace]="isHandheld$ | async"
          [shouldCapitalize]="false">
        </app-select-field>
      </div>
    }
    <div class="slide-container">
      <app-slide-toggle
        [control]="form.controls.allowUse"
        [label]="data.sysText.allowUse">
      </app-slide-toggle>
    </div>
    <div class="add-nonworkday-section">
      <div class="field-container">
        <app-date-field
          #dateInput
          class="non-workday-field"
          [label]="data.sysText.nonWorkday_date"
          [control]="form.controls.nonWorkdayDateAdd"
          [hideIconSpace]="isHandheld$ | async"
          [icon]="'calendar_today'"
          [group]="form">
        </app-date-field>
        <app-input-field
          class="non-workday-field"
          [control]="form.controls.nonWorkdayDescAdd"
          [hideIconSpace]="!(isHandheld$ | async) || (isHandheld$ | async)"
          [label]="data.sysText.nonWorkday_description"
          [inputType]="'string'">
        </app-input-field>
      </div>
      <button
        type="button"
        (click)="onAddNonWorkday()"
        mat-flat-button
        [disabled]="editingRow"
        color="accent"
        class="button">
        {{data.sysText.addNonWorkday | uppercase}}
      </button>
      <div aria-live="polite">
        @if (form.controls.yearNonWorkdayGroups.errors?.notAdded) {
          <mat-error class="mat-error">
            {{ data.sysText.nonWorkdays_notAddedError }}
          </mat-error>
        }
      </div>
      @if (addedMessage) {
        <div class="hint-container">
          <mat-hint class="mat-form-field">
            {{ data.sysText.nonWorkdays_addedMessage
            .replace("@[desc]", addedMessage.desc)
            .replace("@[date]", (addedMessage.date | date)) }}
          </mat-hint>
        </div>
      }
    </div>
    <div class="non-workdays-section">
      @for(yearFormGroup of yearFormGroups.controls; track yearFormGroup; let j = $index) {
        <mat-expansion-panel
          class="info-panel remove-mat-expansion-panel-padding non-workdays"
          [expanded]="yearPanelOpenState.includes(yearFormGroup.controls.year.value)">
          @if (yearFormGroup.controls.year.value) {
            <mat-expansion-panel-header class="no-padding" [ngClass]="{ 'disabled': editingRow }">
              <mat-panel-title>
                <div class="section-header-container">
                  <p class="overline grey1 semibold section-title">
                    {{yearFormGroup.controls.year.value + ' (' + yearFormGroup.controls.nonWorkdays.controls.length + ')'}}
                  </p>
                  <mat-divider class="section-header-underline" aria-hidden="true"></mat-divider>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
          }
          @for(nonWorkdayFormGroup of yearFormGroup.controls.nonWorkdays.controls; track nonWorkdayFormGroup; let i = $index) {
            @let editingThisRow = editingRow?.yearGroupIndex === j && editingRow?.nonWorkdayIndex === i;
            <div class="non-workday-form-row">
              <div class="field-container">
                <div class="non-workday-field date">
                  <div class="container ">
                    <mat-icon [ngClass]="{ focus: input.focused }">{{ 'calendar_today' }}</mat-icon>
                    <mat-form-field color="accent">
                      <mat-label>{{ data.sysText.nonWorkday_date | titlecase }}</mat-label>
                      <input matInput [matDatepicker]="picker" [formControl]="nonWorkdayFormGroup.controls.date" #input="matInput" autocomplete="off"/>
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                      @if (nonWorkdayFormGroup.controls.date.errors?.required && !nonWorkdayFormGroup.controls.date.errors?.matDatepickerParse) {
                        <mat-error>{{ data.sysText.required | capitalizefirst }}</mat-error>
                      }
                      @if (nonWorkdayFormGroup.controls.date.errors?.matDatepickerParse) {
                        <mat-error>{{ data.sysText.invalidDateError }}</mat-error>
                      }
                      @if (nonWorkdayFormGroup.controls.date.errors?.msError) {
                        <mat-error>{{ nonWorkdayFormGroup.controls.date.errors?.msError }}</mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <!-- mat hint for spacing -->
                  @if (!input.errorState) {
                    <mat-hint></mat-hint>
                  }
                </div>
                <app-input-field
                  class="non-workday-field"
                  [control]="nonWorkdayFormGroup.controls.name"
                  [hideIconSpace]="!(isHandheld$ | async)"
                  [label]="data.sysText.nonWorkday_description"
                  [inputType]="'string'">
                </app-input-field>
              </div>
              <div class="form-row-buttons">
                <button
                  type="button"
                  mat-icon-button
                  [disabled]="editingRow"
                  [disableRipple]="true"
                  [attr.aria-label]="data.sysText.delete_ariaLabel"
                  (click)="onRemoveNonWorkday(j, i)">
                  <mat-icon [ngClass]="{ 'disabled': editingRow }">delete</mat-icon>
                </button>
                <!-- one button for edit and done, so it keeps focus when the row switches between them -->
                <button
                  type="button"
                  #rowButton
                  mat-icon-button
                  [disabled]="editingRow && !editingThisRow"
                  [disableRipple]="true"
                  [attr.aria-label]="editingThisRow ? data.sysText.done_ariaLabel : data.sysText.edit_ariaLabel"
                  (click)="editingThisRow ? onSaveNonWorkday(j, i) : onEditNonWorkday(j, i, rowButton)">
                  <mat-icon [ngClass]="{ 'disabled': editingRow && !editingThisRow }">{{ editingThisRow ? 'check' : 'edit' }}</mat-icon>
                </button>
              </div>
            </div>
          }
        </mat-expansion-panel>
      }
    </div>
    <div class="bottom-section">
      @if (yearFormGroups.errors?.msError) {
        <mat-error class="mse-form-error caption bottom-hint">
          {{ yearFormGroups.errors?.msError }}
        </mat-error>
      }
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting || editingRow"
      (click)="cancel()">
      {{ data.sysText.cancel }}
    </button>
  }
  <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks.
  it stays focusable while a row is being edited too, so the guard repeats that check -->
  <button
    mat-stroked-button
    class="button"
    color="accent"
    [disabled]="isSubmitting || editingRow"
    disabledInteractive
    [showProgress]="isSubmitting"
    [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
    (click)="!isSubmitting && !editingRow && onSubmit()">
    {{ data.sysText.save }}
    <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
  </button>
</mat-dialog-actions>
